var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5734 1.05239V10.7215M16.9334 5.53884C18.1917 6.75597 19.0486 8.30655 19.3956 9.99453C19.7427 11.6825 19.5643 13.4321 18.883 15.022C18.2017 16.612 17.0482 17.9709 15.5682 18.927C14.0882 19.883 12.3483 20.3933 10.5684 20.3933C8.78846 20.3933 7.04852 19.883 5.56854 18.927C4.08856 17.9709 2.935 16.612 2.25373 15.022C1.57245 13.4321 1.39405 11.6825 1.74108 9.99453C2.08811 8.30655 2.94499 6.75597 4.20336 5.53884",
    stroke: "#484C50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f306a0bd7886f75c4205ad3570077ebe.svg";
export { ForwardRef as ReactComponent };